import actions from '../../web-sh/src/store/actions'
import authActions from './auth'
import paymentActions from './payment'
import resourceActions from './resource'
import onboardingActions from './onboarding'
import enterpriseActions from './enterprise'
import privateEmailActions from './private-email'
import permissionActions from './permission'

export default {
  ...actions,
  ...authActions,
  ...paymentActions,
  ...resourceActions,
  ...onboardingActions,
  ...enterpriseActions,
  ...privateEmailActions,
  ...permissionActions
}